import { render, staticRenderFns } from "./task_rule_list.vue?vue&type=template&id=9000b806&scoped=true&"
import script from "./task_rule_list.vue?vue&type=script&lang=js&"
export * from "./task_rule_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9000b806",
  null
  
)

export default component.exports